/**
 * Tiny pub/sub bridging low-level realtime transport events (Centrifugo
 * connection/subscription state, token refresh outcomes) into whichever RTC
 * logger is currently active. Keeps `chat/api/realtime.ts` free of any
 * dependency on the logging layer: it only emits; loggers subscribe while a
 * call/meeting is in progress and detach on teardown.
 */

export interface RtcBusEvent {
  type: string;
  data?: Record<string, unknown>;
  at: number;
}

type RtcBusListener = (event: RtcBusEvent) => void;

const listeners = new Set<RtcBusListener>();

export function emitRtcDiagnostic(
  type: string,
  data?: Record<string, unknown>,
): void {
  if (listeners.size === 0) return;
  const event: RtcBusEvent = { type, data, at: Date.now() };
  for (const listener of [...listeners]) {
    try {
      listener(event);
    } catch {
      // A broken logger must never break the transport.
    }
  }
}

export function subscribeRtcDiagnostics(listener: RtcBusListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
